export enum Endpoints {
  BFF = 'bff',
  AUTH0 = 'auth0'
}
